import { RecommendationStoreAdapter } from './storeAdapter';
import { RecommendationItem, RecommendationStoreState } from './types';
import { defaultState } from './utils';

export class RecommendationStore {
    private adapter: RecommendationStoreAdapter;

    state: RecommendationStoreState = defaultState;

    constructor(storeAdapter: RecommendationStoreAdapter) {
        this.adapter = storeAdapter;
        this.state = storeAdapter.getAll();
    }

    update<K extends keyof RecommendationStoreState>(key: K, value: RecommendationStoreState[K]) {
        this.state[key] = value;
        this.save();
    }

    addItem(item: RecommendationItem) {
        this.state.items.push(item);
        this.save();
    }

    /**
     * Finds the recommendationId based on the source of the current item.
     *
     * @example {1} The user clicks on a video recommendation from the home page.
     * Even though the user arrives on the video page, the recommendationId is still the one from the home page.
     * If a recommendation is clicked on the video page, the recommendationId will be the one from the video page.
     *
     * @example {2} The user opens a video with no previous session data.
     * We don't know the recommendation source, so we return null.
     *
     * @param itemId - The id of the current item.
     * @returns The recommendationId for the current item's source.
     */
    findSourceRecommendationId(itemId: string): string | null {
        const item = this.state.items.find((item) => item.id === itemId);

        if (!item) {
            return null;
        }

        return this.state[item.source];
    }

    private save() {
        this.adapter.save(this.state);
    }
}
